export const config: any = {
    pageAddress: "https://hiveslotgames.com",
    gameServerAddress: "https://european-roulette-server.hiveslotgames.com",
    gameId: "European_Roulette",
    straightBetMax: 20,
    splitBetMax: 25,
    streetBetMax: 35,
    cornerBetMax: 40,
    lineBetMax: 50,
    columnBetMax: 120,
    dozenBetMax: 120,
    colorBetMax: 250,
    evenOddBetMax: 250,
    lowHighNumbersBetMax: 250,
    oneNumberMax: 65,
    totalBetMax: 250,
    displayCurrency: "HIVE",
    baseCurrency: "mHIVE",
    baseCurrencyDenomination: 1000,
    smallBets: false,
    extremelySmallBets: false,
};



// WEBPACK FOOTER //
// ./src/config.ts